"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";
import { localeNativeNames, validLocales, type Locale } from "~/i18n/locales";
import { setLocaleAction } from "~/lib/i18n/actions";

type Props = {
  currentLocale: Locale;
  className?: string;
};

// docs/i18n.md §1.4: ロケール切り替えメニューはリソースファイルの存在から
// 動的に生成する(言語名のハードコード配列を持たない) — validLocales/
// localeNativeNames(src/i18n/locales.ts)が唯一の一覧。
export function LocaleSwitcher({ currentLocale, className }: Props) {
  const router = useRouter();
  const t = useTranslations("Common");
  const [pending, setPending] = useState(false);

  async function handleChange(locale: string) {
    setPending(true);
    try {
      await setLocaleAction(locale);
      router.refresh();
    } finally {
      setPending(false);
    }
  }

  return (
    <select
      value={currentLocale}
      disabled={pending}
      onChange={(e) => handleChange(e.target.value)}
      aria-label={t("language")}
      className={`border-disabled bg-surface rounded-lg border px-2 py-1 text-sm ${className ?? ""}`}
    >
      {validLocales.map((locale) => (
        <option key={locale} value={locale}>
          {localeNativeNames[locale]}
        </option>
      ))}
    </select>
  );
}
